/*global Modernizr, trapFocus, alert, console */
/*jslint browser:true */

(function() {
  'use strict';

  var location_search_modal_container = document.getElementById('modal-location-search');
  if(location_search_modal_container) {
    location_search_modal_container.addEventListener('modal-open', (e) => {
      setTimeout(function() {
        trapFocus(location_search_modal_container);
      }, 30);
    });
  }

  var location_search_forms = document.querySelectorAll('.js-location-search-form');
  if(location_search_forms) {
    location_search_forms.forEach((location_search_form) => {
      var search_zipcode = location_search_form.querySelector('input[name="zip"]'),
          search_city = location_search_form.querySelector('select[name="city"]');

      location_search_form.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if(search_zipcode.value !== '' && search_zipcode.value.length === 5) {
          document.location = '/locations/zipcode/' + search_zipcode.value;
        }

        return false;
      });

      if(search_city) {
        search_city.addEventListener('change', (e) => {
          var city = search_city.options[search_city.selectedIndex],
              state = city.parentNode.getAttribute('data-slug');

          document.location = '/locations/' + state + '/' + city.value;
        });
      }
    });
  }

  var geo_triggers = document.querySelectorAll('.location-search-geolocation');
  if(geo_triggers) {
    geo_triggers.forEach((geo_trigger) => {
      geo_trigger.addEventListener('click', (e) => {
        e.preventDefault();

        var geoCookie = getCookie('dd_geo');

        if(geoCookie !== null) {
          if(document.location.pathname === '/locations' || document.location.pathname.startsWith('/locations/')) {
            const geo_init = new Event('load-geolocation');
            document.body.dispatchEvent(geo_init);
            return;
          }

          location.href = '/locations/geolocation';
          return;
        }

        var geoSuccess = function(position) {
          var data = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          setCookie('dd_geo', JSON.stringify(data), 3);

          if(document.location.pathname === '/locations' || document.location.pathname.startsWith('/locations/')) {
            const geo_init = new Event('load-geolocation');
            document.body.dispatchEvent(geo_init);
            return;
          }

          location.href = '/locations/geolocation';
          return;
        };

        var geoError = function() {
          alert('Could not get your location.');
        };

        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition(geoSuccess, geoError);
        } else {
          geoError();
        }
      });
    });
  }

  function setCookie(name,value,days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)===' '){ c = c.substring(1,c.length); }
      if (c.indexOf(nameEQ) === 0){ return c.substring(nameEQ.length,c.length); }
    }
    return null;
  }
}());
